<template>
  <div class="left_bar_wrapper">
    <div class="lef_bar_top">
      {{ title }}
    </div>
    <div class="lef_bar_bottom">
      <ul>
        <li
          v-for="(t, i) in subTitleList"
          :key="i"
          :class="{
            sub_title: true,
            active: selectedTitle === t
          }"
          @click="selectSubTitle(t)"
        >
          {{ t }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftBar",
  props: {
    title: {
      type: String,
      default: "四字标题"
    },
    subTitleList: {
      type: Array,
      default: () => {
        return ["小标题一", "小标题二"];
      }
    },
    preSelected: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedTitle: ""
    };
  },
  mounted() {
    if (this.subTitleList.includes(this.preSelected)) {
      this.selectSubTitle(this.preSelected);
    }
  },
  methods: {
    selectSubTitle(title) {
      this.selectedTitle = title;
      this.$emit("handleSelect", title);
    }
  }
};
</script>

<style scoped>
.lef_bar_top {
  height: 80px;
  line-height: 80px;
  color: white;
  width: 140px;
  font-size: 18px;
  padding-left: 200px;
  background: url("@/assets/leftbar_bg.jpg") no-repeat;
  background-size: cover;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.sub_title {
  border-bottom: 1px dashed #4a4a4a;
  background-color: #f5f5f5;
  padding-left: 40px;
  text-align: left;
  line-height: 70px;
}

.active {
  background-color: #63065f;
  color: white;
}

.sub_title:last-child {
  border-bottom: none;
}
</style>
